import { OreDivider, OreHeading } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { PageWrapper } from '@/Shared/ui/layout'
import { MyStoreFormRestaurant } from '@/Store/ui/organisms'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { useUserData } from '@/User/ui/context'

export const MyStorePage = (): JSX.Element => {
  const { t } = useTranslation()
  const { merchant } = useUserData()

  return (
    <PageWrapper
      paddingSmaller
      paddingTop={8}
      style={{
        paddingRight: 40,
        paddingLeft: 40,
        minWidth: '-webkit-fill-available',
        marginRight: 0,
        marginLeft: 0,
      }}
    >
      <OreHeading as="h1" size="title-sm">
        {t(
          merchant.isNursery
            ? storesTranslation.myStore.pageTitleGuarderia
            : storesTranslation.myStore.pageTitle,
        )}
      </OreHeading>
      <OreDivider space="larger-bottom" />
      <MyStoreFormRestaurant />
    </PageWrapper>
  )
}
